import { MiraCustomerBlocking } from '../../../shared/types/customer';

export const isCustomerBlocked = (blocking: MiraCustomerBlocking) =>
  blocking.blockedAll ||
  blocking.blockedConfirmation ||
  blocking.blockedInvoice ||
  blocking.blockedPacking ||
  blocking.blockedPicking;
